/**
 * Injects form data into hidden fields so that dynamic content can be added to a confirmation email.
 *  DATA Object structure for data-js-confirmation-copy is object {"value that will trigger this content": {"hidden field name": "dynamic content for this hidden field"}}
 * @returns {[undefined]} []
 */

function confirmationContent() {
  const cc = Array.from(
    document.querySelectorAll('[data-js-confirmation-copy]'),
  );

  cc.length &&
    cc.forEach((question) => {
      const select = question.querySelector('select');
      let data;

      try {
        data = JSON.parse(question.getAttribute('data-js-confirmation-copy'));
      } catch (error) {
        console.error(error);
        return;
      }

      select.addEventListener('change', () => {
        const updates = data[select.value];

        Object.keys(updates).forEach((name) => {
          const field = document.querySelector(`[name=${name}]`);
          field.value = updates[name];
        });
      });
    });
}

export function init() {
  confirmationContent();
}
